import {
	dialog,
} from '../actions';

const initialState = {
	isOpen: false,
	payload: null,
	dialogs: {},
};

const dialogReducer = (state = initialState, action) => {
	switch (action.type) {
		case dialog.OPEN_DIALOG:
			return {
				...state,
				dialogs: {
					...state.dialogs,
					[action.id]: action.payload,
				},
			};
		case dialog.CLOSE_DIALOG:
			if (!action.id) {
				return {
					...state,
					dialogs: {},
				};
			}

			return {
				...state,
				dialogs: Object.keys(state.dialogs).reduce((acc, id) => (id === action.id ? acc : { ...acc, [id]: state.dialogs[id] }), {}),
			};
		case dialog.CLOSE_ALL_DIALOGS:
			return {
				...state,
				isOpen: false,
				payload: null,
				dialogs: {},
			};
		default:
			return state;
	}
};

export default dialogReducer;
